import React from 'react';
import { Error } from '@k3imagine/self-serve-components';

const ErrorPage = () => (
  <Error title="Ooopsss..." message="QR code is invalid" icon="Spaceship" />
);

export default ErrorPage;
